export default {
    baseStyle: {
        cardContainer: {
            p: ['24px 16px', null, '32px 40px'],
            bg: 'white',
            align: 'flex-start',
            border: '1px solid',
            borderColor: 'borderGray',
            backgroundColor: 'white'
        },
        cardHeading: {
            fontSize: '3xl',
            textTransform: 'uppercase'
        },
        cardImage: {
            width: {base: '85px', sm: '85px', md: '147px'}
        }
    },
    parts: ['cardContainer', 'cardHeading', 'cardImage']
}
